module.exports = __webpack_public_path__ + "img/button.60ed95cd.png";